import React from 'react';
import {Popup} from 'semantic-ui-react';

import {IconBan, IconEdit, IconX} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import {editClick} from '@modules/client/utils/apiKeyHelpers';

export const renderActionsColumn = (row, clientId) => {
    const ACTION_MESSAGE = row['is_disabled'] ?
        'Remove this API key.'
        : 'Disable this API key.';
    const icon = row['is_disabled']
        ? <IconX size='large' onClick={editClick} onClickElement={row}/>
        : <IconBan flipped='vertically' size='large' onClick={editClick} onClickElement={row}/>;

    return (
        <div className='actions-list-icon'>
            <IconEdit
                link={getLink('clients.apiKey.edit', {id: clientId, clientApiKeyId: row.id})}
                size='large'
            />
            <Popup
                content={ACTION_MESSAGE}
                key={row['id']}
                position='left center'
                style={{textAlign: 'left'}}
                trigger={icon}
            />
        </div>
    );
};
